import { Text } from '@agro-club/agroclub-shared'
import { Company } from 'modules/domain/company/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'views/components/Card/Card'
import { CompanyBranch } from './CompanyBranch'
import { refetchFunc } from 'modules/domain/common/hooks'

type Props = {
  branches: Company[]
  currentCompanyId: number | string
  refetch: refetchFunc
}
export const CompanyBranches: FC<Props> = ({ branches, currentCompanyId, refetch }) => {
  const { t } = useTranslation('company')
  const [mainBranch, ...rest] = branches

  return (
    <Card.Container>
      <Card.GapableContent>
        <Card.Title>{t('linkedCompanies')}</Card.Title>
        <CompanyBranch branch={mainBranch} isMain isCurrent={mainBranch.id == currentCompanyId} refetch={refetch} />
        <Card.GapableContent>
          <Text color="secondary">{t('extraCompanies')} </Text>
          {rest.map((branch) => (
            <CompanyBranch
              key={branch.id}
              branch={branch}
              isCurrent={branch.id == currentCompanyId}
              refetch={refetch}
            />
          ))}
        </Card.GapableContent>
      </Card.GapableContent>
    </Card.Container>
  )
}
